import React from "react";
import {
  Jumbotron, Row,
  Col, Container
} from "react-bootstrap";
import {
  highlights, jumbotron, jumbotronHighlight, highlightTitleSecond,
  highlightImg, highlightTitle, highlightSubtitle,
  jumbotronBackground, sliderOnMobile, rowOnDesktop
} from "./style.mod.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import asHTML from "helpers/as-html";
import Image from "components/image";

const ProductHighlights = ({ data }) => {
  const { title, highlight, bgColor, sliderMobile } = data;

  const settings = {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    modules: [Pagination],
    pagination: { clickable: true }
  };

  const jumbotronBgColor = data?.jumbotronBgColor?.hex;
  const topBgColor = data?.topBgColor?.hex;


  return (
    <div className={jumbotron}
      style={{ backgroundColor: topBgColor ? topBgColor : "inherit" }}>
      <Jumbotron className={jumbotronBackground} style={{ backgroundColor: jumbotronBgColor }} />
      <Container>
        <div className={`${jumbotronHighlight} ${sliderMobile ? "no-margin" : ""}`} style={{ backgroundColor: bgColor && bgColor.hex }}>
          {title && <h2>{title}</h2>}
          {
            sliderMobile ?
              <>
                <div className={sliderOnMobile}>
                  <Swiper {...settings}>
                    {highlight?.map((h) => (
                      <SwiperSlide className={highlights} key={h._key}>
                        <Image className={highlightImg} image={h?.image} alt={h?.image?.alt} />
                        <p className={highlightTitle}>{asHTML(h.title)}</p>
                        {h.Subtitle ? <p className={highlightSubtitle}>{h.Subtitle}</p> : ""}

                      </SwiperSlide>
                    )
                    )}
                  </Swiper>
                </div>
                <div className={rowOnDesktop}>
                  <Row>
                    {highlight?.map((h) => (
                      <Col lg={highlight.length === 2 ? 6 : highlight.length === 3 ? 4 : 3} xs={6} key={h._key}>
                        <div className={highlights}>
                          <Image className={highlightImg} image={h?.image} alt={h.image?.alt} />
                          <p className={highlightTitleSecond}>{asHTML(h.title)}</p>
                          {h.Subtitle ? <p className={highlightSubtitle}>{h.Subtitle}</p> : ""}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </>
              :
              <Row>
                {highlight?.map((h) => (
                  <Col lg={highlight.length === 2 ? 6 : highlight.length === 3 ? 4 : 3} xs={6} key={h._key}>
                    <div className={highlights}>
                      <Image className={highlightImg} image={h?.image} alt={h.image?.alt} />
                      <p className={highlightTitleSecond}>{asHTML(h.title)}</p>
                      {h.Subtitle ? <p className={highlightSubtitle}>{h.Subtitle}</p> : ""}
                    </div>
                  </Col>
                ))}
              </Row>
          }
        </div>
      </Container>
    </div>
  );
};

export default ProductHighlights;
